import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, ShieldCheck } from 'lucide-react';
const HeaderEMFEV = () => {
  return <header className="bg-white" data-id="element-3437">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-3438"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-3439">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-3440">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-3441">
            MEDPRESS GAZETTE
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-3442">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-3443">
          <div className="text-left" data-id="element-3444">VOL. 128, NO. 47</div>
          <div className="text-left sm:text-center" data-id="element-3445">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-3446">
            TECHNOLOGY & HEALTH SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-3447">
        <div className="max-w-4xl mx-auto" data-id="element-3448">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-3449">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-3450">
            The EV "Cabin Pressure" — Why It Happens and How to Get Rid of It
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-3451">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-3452">
              <img src="https://cdn.magicpatterns.com/uploads/ao7Z7fWwLyCEntEDbxTayA/1.png" alt="Rober Kellner" className="w-full h-full object-cover" data-id="element-3453" />
            </div>
            <div className="flex-1" data-id="element-3454">
              <div className="flex items-center" data-id="element-3455">
                <div className="font-medium text-gray-900 text-lg" data-id="element-3456">
                  By Robert Kellner, P.E. (Ret.)
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-3457">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-3458" />
                  <span className="text-xs ml-1 font-medium" data-id="element-3459">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-3460">
                Los Angeles, CA • Retired Electrical Engineer • 65 Years Old •
                Former Senior Systems Engineer, Raytheon
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-3461">
                <div className="flex items-center mr-4" data-id="element-3462">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-3463" />
                  <span data-id="element-3464">14 min read</span>
                </div>
                <div className="flex items-center" data-id="element-3465">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-3466" />
                  <span data-id="element-3467">38,741 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-3468">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-3469" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-3470">
                  Patricia Chen, RN, MSN
                </span>
              </div>
            </div>
          </div>

          <div className="mb-5" data-id="element-3471">
            <img src="https://cdn.magicpatterns.com/uploads/nhkS6xB1MDX2Gs8mw3HfUW/2.png" alt="Tesla Model S silhouette at sunset with text overlay: The Real Reason You Have Brain Fog In Your Electric Vehicle" className="w-full rounded-lg shadow-md" data-id="element-3472" />
          </div>

          <div className="my-4 border-l-4 border-gray-800 pl-6 py-4 bg-gradient-to-r from-gray-100 to-white shadow-sm" data-id="element-3473">
            <p className="text-sm uppercase tracking-wide text-gray-500 mb-2 font-semibold" data-id="element-3474">
              ARTICLE SUMMARY
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic" data-id="element-3475">
              "What a retired electrical engineer discovered after 6 months of
              debilitating headaches, nausea, and brain fog in his new Tesla
              Model S — and the counterintuitive fix that gave him his car back.
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-3476">
              — now shared with 14,000+ EV owners across three forums."
            </p>
          </div>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-3477">
            <div className="mb-1 flex items-center" data-id="element-3478">
              <span className="font-medium mr-2" data-id="element-3479">Published by:</span>
              MedPress Gazette Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-3480">
              <span className="font-medium mr-2" data-id="element-3481">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderEMFEV;